<template>
  <div>
    <el-input
      ref="input"
      :value="value"
      :readonly="readonly"
      v-bind="$attrs"
      @input="e => this.$emit('input', e)"
      class="text-area-rounded-0 text-area-border-0 word-break-normal"
    ></el-input>
    <slot name="attachments"></slot>
    <div class="d-flex mx-2 my-1 line-height-10">
      <div class="flex-grow-1 d-flex gap-2 align-items-center">
        <slot name="bottom-left-tools-before"></slot>
        <placeholders
          :disabled="readonly"
          :multiple="false"
          @select="insertPlaceholder"
        >
          <Button :disabled="readonly" title="Add placeholders">
            <i class="fas fa-code fa-fw"></i>
          </Button>
        </placeholders>
        <Emoji
          :disabled="readonly"
          :multiple="true"
          @select="insertEmoji"
        >
          <Button :disabled="readonly" title="Add emoji">
            <i class="far fa-smile fa-fw"></i>
          </Button>
        </Emoji>
        <slot name="bottom-left-tools-after"></slot>
      </div>
      <div class="flex-shrink-0">
        <slot name="bottom-right-tools"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Placeholders from '../placeholder/index.vue';
import Emoji from '../emoji/'
import EmailPlaceholder from "../placeholder/email-index.vue";
import InputMixin from "../../../mixins/inputs";
import Button from "./button.vue";

export default {
  components: {
    EmailPlaceholder,
    Placeholders,
    Emoji,
    Button,
  },

  mixins: [
    InputMixin,
  ],

  props: {
    value: String,
    readonly: Boolean,
  },

  methods: {
    /**
     * @param value
     */
    insertPlaceholder(value) {
      this.insertText(value);
    },

    /**
     * @param value
     */
    insertEmoji({native}) {
      this.insertText(native);
    },

    /**
     * @param value
     */
    insertText(value) {
      this.addTextInCursorPosition(
        this.$refs.input.$refs.textarea,
        _.toString(this.value),
        value,
        value => this.$emit('input', value)
      );
    },
  },
}
</script>
